
	export default {
		computed: {
			progress () {
				return this.$store.state.progress
			}
		}
	}
